import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-view-class-dialog',
  templateUrl: './view-class-dialog.component.html',
  styleUrls: ['./view-class-dialog.component.css'],
})
export class ViewClassDialogComponent implements OnInit {
  public data: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<ViewClassDialogComponent>,
  ) {
    if (this.dialogData) {
      this.data = this.dialogData.data;
      console.log(this.dialogData);
    }
  }

  ngOnInit(): void {}
  close() {
    this.dialogRef.close(true);
  }
}
